export default __webpack_public_path__ + "static/054-f68e3782886e48a2b6b4d50a89987166.jpg";